 

export const ADMIN_EMPLOYES_DATA_FAIL="ADMIN_EMPLOYES_DATA_FAIL"
export const ADMIN_EMPLOYES_DATA_REQ="ADMIN_EMPLOYES_DATA_REQ"
export const ADMIN_EMPLOYES_DATA_SUCC="ADMIN_EMPLOYES_DATA_SUCC"


 
 

export const ADMIN_EMPLOYES_DATA_SUCC_SEARCH="ADMIN_EMPLOYES_DATA_SUCC_SEARCH"



export const ADMIN_EMPLOYES_DATA_SEARCH="ADMIN_EMPLOYES_DATA_SEARCH"


export const ADMIN_EMPLOYES_DATA_FILTER="ADMIN_EMPLOYES_DATA_FILTER"
// export const ADMIN_EMPLOYES_DATA_ROLE="ADMIN_EMPLOYES_DATA_ROLE"
// export const ADMIN_EMPLOYES_DATA_TYPE="ADMIN_EMPLOYES_DATA_TYPE"